<template>
  <div>
    <div class="mb-6">
      <div class="text-2xl font-bold mb-2">General</div>

      <div class="xl:w-1/3 mb-4">
        <jet-label for="name" value="Customer Name" />
        <jet-input type="text" class="block w-full" v-model="form.name" ref="name" />
        <jet-input-error :message="$page.props.errors.name" class="mt-1" />
      </div>

      <div class="xl:w-1/3 mb-4">
        <jet-label for="sales_rep_id" value="Sales Rep:" />
        <multiselect
          v-model="form.sales_rep_id"
          valueProp="id"
          label="name"
          :options="salesReps"
          :classes="{ singleLabel: 'w-full px-2' }"
          class="multi-lg"
          placeholder="Select rep"
        />
        <jet-input-error :message="$page.props.errors.sales_rep_id" class="mt-1" />
      </div>

      <div class="xl:w-1/3 mb-4">
        <jet-label for="type" value="Type" />
        <multiselect
          v-model="form.type"
          :options="typeOptions"
          :classes="{ singleLabel: 'w-full px-2' }"
          class="multi-lg"
          placeholder="Select type"
        />
        <jet-input-error :message="$page.props.errors.type" class="mt-1" />
      </div>

      <div class="xl:w-1/3 mb-4">
        <jet-label for="pricing_level" value="Pricing Level" />
        <multiselect
          v-model="form.pricing_level_id"
          :options="pricingOptions"
          placeholder="Select level"
          :classes="{ singleLabel: 'w-full px-2' }"
          class="multi-lg"
        />
        <jet-input-error :message="$page.props.errors.pricing_level_id" class="mt-1" />
      </div>
    </div>

    <div class="mb-6">
      <div class="text-2xl font-bold mb-2">Users</div>
      <jet-input-error :message="$page.props.errors.users" class="mt-1" />

      <div class="rounded-t overflow-hidden border border-b-0">
        <table class="table w-full">
          <thead>
            <tr>
              <th class="text-left w-1/3">Name</th>
              <th class="text-left">Email</th>
              <th class="w-0"></th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="(user, index) in form.users" :key="index">
              <td class="align-top">
                <jet-input
                  type="text"
                  class="block w-full"
                  v-model="user.name"
                  placeholder="Full name"
                />
                <jet-input-error
                  :message="$page.props.errors?.[`users.${index}.name`]"
                  class="mt-1"
                />
              </td>

              <td class="align-top">
                <jet-input
                  type="email"
                  class="block w-full"
                  v-model="user.email"
                  placeholder="email@example.com"
                />
                <jet-input-error
                  :message="$page.props.errors?.[`users.${index}.email`]"
                  class="mt-1"
                />
              </td>

              <td class="align-top text-right whitespace-nowrap">
                <jet-tertiary-button
                  type="button"
                  class="h-7 leading-none"
                  @click="removeUser(index)"
                  :disabled="form.users.length <= 1"
                  title="Remove user"
                >
                  Remove
                </jet-tertiary-button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="mt-3">
        <jet-button type="button" class="h-7 leading-none" @click="addUser">
          Add User
        </jet-button>
      </div>
    </div>
  </div>
</template>

<script>
import JetLabel from '@/Jetstream/Label'
import JetInput from '@/Jetstream/Input'
import JetInputError from '@/Jetstream/InputError.vue'
import JetButton from '@/Jetstream/Button'
import JetSecondaryButton from '@/Jetstream/SecondaryButton'
import JetTertiaryButton from '@/Jetstream/TertiaryButton'
import Multiselect from '@vueform/multiselect'

import '@vueform/multiselect/themes/default.css'

export default {
  props: {
    form: Object,
    salesReps: Array,
    typeOptions: Array,
    pricingOptions: Array,
  },

  components: {
    JetLabel,
    JetInput,
    JetInputError,
    JetButton,
    JetSecondaryButton,
    JetTertiaryButton,
    Multiselect,
  },

  methods: {
    addUser() {
      if (!Array.isArray(this.form.users)) this.form.users = []
      this.form.users.push({ name: null, email: null })
    },

    removeUser(index) {
      if (this.form.users.length <= 1) return
      this.form.users.splice(index, 1)
    },
  },

  mounted() {
    if (!Array.isArray(this.form.users) || this.form.users.length === 0) {
      this.form.users = [{ name: null, email: null }]
    }

    if (this.$refs.name) this.$refs.name.focus()
  },
}
</script>
